{
  "name": "Rainbow Fruit Increase Button",
  "powerupName": "RainbowFruitDescription",
  "levelUpDescriptions": [
    "RainbowFruitUpgradeDescription1",
    "RainbowFruitUpgradeDescription2",
    "RainbowFruitUpgradeDescription3",
    "RainbowFruitUpgradeDescription4",
    "RainbowFruitUpgradeDescription5"
  ]
}